import { ABC_GET_MY_PDD } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import ABCGetMyPDD from './index';
import ABCGetMyPDDThunk from './thunk';

const module: ModulesList = {
  [ABC_GET_MY_PDD]: {
    path: '/getMyPDD',
    component: ABCGetMyPDD,
    thunk: ABCGetMyPDDThunk,
  } as Module,
};

export default module;
